import createCustomerApi from '@/api/post/customer/create-customer';
import Alert from '@/components/alert/alert-component';
import SubmitCard from '@/components/card/submit-card-component';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import { APP_CONTEXT } from '@/utils/context';
import { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import CustomerForm from './customer-form';

/**
 *
 * @returns {JSX.Element} The rendered Customer New page component.
 */
const CustomerNew = () => {
  const { currentUser } = useContext(APP_CONTEXT);
  const navigate = useNavigate();
  const { state } = useLocation();

  return (
    <FormWrapper
      defaultValues={{
        name: '',
        contact_number: '',
        contact_person: [
          {
            id: uuidv4(),
            name: '',
            email: '',
            contact_number: '',
            position: '',
            default_recipient_of_quotes: true,
          },
        ],
        operating_site: [
          {
            name: '',
            country: '',
            nearest_town: '',
            site_commodity: '',
            other: '',
          },
        ],
      }}
      onSubmit={(sValues) => {
        const values = { ...sValues };
        const contactPerson = values.contact_person.map((price) => price);
        const operatingSite = values.operating_site.map((price) => price);

        delete values.contact_person;
        delete values.operating_site;

        const submitValues = {
          customer: {
            ...values,
            is_archived: false,
            added_by_user: currentUser.id,
          },
          contactPerson: { add: contactPerson },
          operatingSite: { add: operatingSite },
        };
        createCustomerApi(submitValues).then(({ data }) => {
          if (state?.quoteForm) {
            const { formData, tab } = state;
            formData.company_id = data?.id;
            navigate(`/shop/sales/main-summary/${formData.quote.id}/quote`, {
              state: { formData, tab, quoteId: formData.quote.id },
            });
          } else {
            navigate(`/shop/customer-management`);
          }
          Alert({
            icon: 'success',
            text: 'Customer created successfully',
          });
        });
      }}
    >
      <CustomerForm />
      <SubmitCard
        padding="0"
        primaryButtonTitle="Save"
        primaryButtonType="submit"
        primaryButtonDisabled={false}
        primaryButtonWidth="112px"
        secondaryButtonType="button"
        secondaryButtonDisabled={false}
        secondaryButtonWidth="112px"
        isLoading={false}
        secondaryButtonTitle="Cancel"
        submitClickSecondary={() => navigate(-1)}
      />
    </FormWrapper>
  );
};

export default CustomerNew;
